var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBulb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 50,
    viewBox: "0 0 44 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4997 46.8015H27.5003V49.9998H16.4997V46.8015Z",
    fill: "#47B16A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9631 32.7586C12.3945 31.5718 11.697 30.4437 10.89 29.4058C8.93428 26.8902 7.8909 23.7464 7.95233 20.5535C8.09988 12.887 14.4767 6.72296 22.1726 6.81773C29.7614 6.90907 36.0504 13.2531 36.0504 20.828C36.0504 23.0365 35.5493 25.1506 34.5611 27.1115L31.6976 25.6746C32.4591 24.1636 32.8453 22.5329 32.8453 20.8279C32.8453 14.9371 28.0403 10.0867 22.1341 10.0157C16.1933 9.94049 11.2708 14.6989 11.1569 20.6147C11.1089 23.115 11.8923 25.4769 13.4225 27.4451C14.3694 28.663 15.1878 29.9866 15.855 31.3791L12.9631 32.7586Z",
    fill: "#47B16A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0191 32.844L28.1215 31.4771C28.6158 30.4335 29.1976 29.417 29.8506 28.4558L32.5036 30.2504C31.9427 31.076 31.4433 31.9485 31.0191 32.844Z",
    fill: "#47B16A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0504 43.9348H17.9496C16.2043 43.9348 14.7843 42.5185 14.7843 40.7775V40.777C14.7843 39.3241 14.6123 37.869 14.273 36.4519C14.0361 35.4626 14.8123 34.4812 15.8316 34.4812H28.1793C29.201 34.4812 29.9777 35.4669 29.7366 36.4576C29.391 37.8783 29.2158 39.3317 29.2158 40.7774C29.2157 42.5184 27.7958 43.9348 26.0504 43.9348ZM17.9893 40.7365H26.0106C26.0126 39.7166 26.0884 38.6943 26.2374 37.6794H17.7672C17.913 38.6923 17.9874 39.7149 17.9893 40.7365Z",
    fill: "#47B16A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3974 0H23.6026V4.29562H20.3974V0Z",
    fill: "#47B16A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03087 9.99584L5.83878 6.81293L8.10427 4.55054L11.2964 7.73355L9.03087 9.99584Z",
    fill: "#47B16A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.418793 19.0681H5.26089V22.2664H0.418793V19.0681Z",
    fill: "#47B16A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7391 19.0681H43.5812V22.2664H38.7391V19.0681Z",
    fill: "#47B16A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9691 9.99584L32.7036 7.73355L35.8957 4.55054L38.1612 6.81293L34.9691 9.99584Z",
    fill: "#47B16A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4952 25.0615L16.5127 22.4294L18.6361 20.0337L20.452 21.6363L25.2561 16.5193L27.5952 18.7059L21.7265 24.957C21.2343 25.5152 20.2994 25.7196 19.4952 25.0615Z",
    fill: "#47B16A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBulb);
export default __webpack_public_path__ + "static/media/icon_bulb.8df2acd1cec4821e887cd4b24822ff2e.svg";
export { ForwardRef as ReactComponent };